/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useStaticQuery, graphql } from 'gatsby'

/**
 * Query latest article
 */
export default function useLatestProject() {
  const {
    allMarkdownRemark: { edges }
  } = useStaticQuery(graphql`
    query latestPublishedProject {
      allMarkdownRemark(
        filter: {
          fileAbsolutePath: { regex: "/(projects)/.*\\.md$/" }
          frontmatter: { published: { ne: "No" } }
        }
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 1
      ) {
        edges {
          node {
            excerpt(pruneLength: 160)
            timeToRead
            fields {
              slug
            }
            frontmatter {
              title
              subtitle
              date(formatString: "YYYY-MM-DD")
              publishedBy
              image {
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  return edges[0]
}
